<template>
  <div
    style="background-color: white"
    class="p-4"
  >
    <b-modal
      id="modal-curso"
      title="Confirmação de exclusão de Curso"
      cancel-title="cancelar"
      cancel-variant="outline-secondary"
      ok-variant="danger"
      ok-title="Deletar"
      centered
      @ok="deletarCurso()"
    >
      <b-card-text>
        <slot name="content-message">
          Tem certeza de que deseja <strong>excluir</strong> esse Curso?
        </slot>
      </b-card-text>
    </b-modal>
    <b-modal
      id="modal-lg"
      ok-only
      ok-title="Salvar"
      centered
      size="lg"
      title="Criar curso"
      @ok="salvarCurso()"
    >
      <b-form-group
        label="Nome Curso"
        label-for="basicInput"
      >
        <b-form-input
          id="basicInput"
          v-model="nomeCursoNOVO"
        />
      </b-form-group>
      <div>
        <label for="textarea-default">Descrição</label>
        <b-form-textarea
          id="textarea-default"
          v-model="descricaoCursoNOVO"
          rows="3"
        />
      </div>
      <div class="mt-3">
        <label for="input-file">Imagem capa</label>
        <input-file-custom
          id="input-file"
          @atualizarImagem="updatedImagem($event)"
        />
      </div>

    </b-modal>
    <b-row>
      <b-row>
        <b-col
          md="2"
          sm="4"
          class="my-1"
        >
          <h3>Cursos</h3>
        </b-col>
      </b-row>
      <b-col
        md="2"
        sm="4"
        class="my-1"
      >
        <b-form-group
          class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Mostrar</label>
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            :options="pageOptions"
            class="w-50"
          />
        </b-form-group>
      </b-col>
      <b-col
        class="my-1 d-flex justify-content-end"
      >
        <b-button
          v-b-modal.modal-lg
          class="bg-danger"
          style="border: none"
        >
          + Curso
        </b-button>
      </b-col>
      <b-col cols="12">
        <b-table
          striped
          hover
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          :items="cursos"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #cell(capa)="data">
            <b-avatar :src="data.value" />
          </template>

          <template #cell(status)="data">
            <b-badge :variant="status[1][data.value]">
              {{ status[0][data.value] }}
            </b-badge>
          </template>
          <template #cell(Ações)="data">
            <div>
              <b-button
                v-b-tooltip.hover.top="'Editar'"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                size="sm"
                variant="primary"
                class="mr-2"
                @click="editCurso(data.item.id)"
              >
                <feather-icon

                  icon="EditIcon"
                  stroke="white"
                >
                  />
                </feather-icon>
              </b-button>
              <b-button
                v-b-tooltip.hover.top="'Estatisticas'"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                size="sm"
                variant="primary"
                class="mr-2"
                @click="estatisticaCurso(data.item.id)"
              >
                <feather-icon

                  icon="ActivityIcon"
                  stroke="white"
                >
                  />
                </feather-icon>
              </b-button>
              <b-button
                v-b-tooltip.hover.top="'Deletar'"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                size="sm"
                variant="primary"
                class="mr-2"
                @click="showModalDelete1(data.item.id)"
              >
                <feather-icon

                  icon="TrashIcon"
                  stroke="white"
                >
                  />
                </feather-icon>
              </b-button>
            </div>
            <!--            <b-dropdown-->
            <!--              variant="link"-->
            <!--              no-caret-->
            <!--              :right="$store.state.appConfig.isRTL"-->
            <!--            >-->
            <!--              <template #button-content>-->
            <!--                <feather-icon-->
            <!--                  icon="MoreVerticalIcon"-->
            <!--                  size="16"-->
            <!--                  class="align-middle text-body"-->
            <!--                />-->
            <!--              </template>-->
            <!--              <b-dropdown-item @click="editCurso(data.item.id)">-->
            <!--                <feather-icon icon="FileTextIcon" />-->
            <!--                <span class="align-middle ml-50">Editar</span>-->
            <!--              </b-dropdown-item>-->
            <!--              <b-dropdown-item-->
            <!--                v-ripple.400="'rgba(30, 30, 30, 0.15)'"-->
            <!--                @click="estatisticaCurso(data.item.id)"-->
            <!--              >-->
            <!--                <feather-icon icon="ActivityIcon" />-->
            <!--                <span class="align-middle ml-50">Estatisticas</span>-->
            <!--              </b-dropdown-item>-->
            <!--              <b-dropdown-item-->
            <!--                v-ripple.400="'rgba(30, 30, 30, 0.15)'"-->
            <!--                @click="showModalDelete1(data.item.id)"-->
            <!--              >-->
            <!--                <feather-icon icon="TrashIcon" />-->
            <!--                <span class="align-middle ml-50">Deletar</span>-->
            <!--              </b-dropdown-item>-->
            <!--            </b-dropdown>-->
          </template>

        </b-table>
      </b-col>

      <b-col
        cols="12"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          size="sm"
          class="my-0"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BFormTextarea,
  BCardText,
  BModal,
} from 'bootstrap-vue'
import InputFileCustom from '@/views/App/Cursos/InputFileCustom.vue'
import { useApi, useApiAWS } from '@/composables/useApi'

const apiBack = useApi()
const apiAws = useApiAWS()

export default {
  components: {
    BModal,
    InputFileCustom,
    BFormTextarea,
    BCardText,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
  },
  data() {
    return {
      selectedFile: null,
      cursoSelecionado: '',
      cursos: [],
      nomeCursoNOVO: '',
      descricaoCursoNOVO: '',
      imagemCursoNOVO: '',
      capa: '',
      perPage: 5,
      pageOptions: [3, 5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        // {
        //   key: 'id', label: 'Id',
        // },
        { key: 'capa', label: 'Capa' },
        { key: 'nome', label: 'Nome', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'Ações', label: 'Ações', sortable: true },
      ],

      status: [{
        1: 'Ativo', 0: 'Inativo',
      },
      {
        0: 'light-primary', 1: 'light-success',
      }],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    getUserData: {
      get() {
        const newUserData = JSON.parse(localStorage.getItem('userData'))
        if (newUserData !== null) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.domainUser = newUserData.user_domain
          return newUserData
        }
        return {}
      },
      set(value) {
        localStorage.setItem('userData', JSON.stringify(value))
      },
    },
  },
  async mounted() {
    // Set the initial number of items
    this.totalRows = this.cursos.length
    await this.listarCurso()
  },
  methods: {
    editCurso(id) {
      localStorage.setItem('cursoId', id)
      return this.$router.push(`/editCurso/${id}`)
    },
    estatisticaCurso(id) {
      return this.$router.push(`/staticsCurso/${id}`)
    },
    showModalDelete1(item) {
      this.cursoSelecionado = item
      this.$bvModal.show('modal-curso')
    },
    async listarCurso() {
      await apiBack.get(`/getCursosById?id=${this.getUserData.id}`)

        .then(data => {
          this.cursos = data.data
        })
        .catch(err => console.error(err))
    },
    async deletarCurso() {
      await apiBack.delete(`/deleteCurso?id=${this.cursoSelecionado}`)
        .then(data => {
          console.log(data)
          this.listarCurso()
          this.$message({
            type: 'success',
            message: 'Deletado com sucesso',
          })
        })
        .catch(err => console.error(err))
    },

    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    selecionaImagem(capa) {
      this.capa = capa
    },
    async onFileChange(event) {
      const file = event.target.files[0]
      // await this.uploadAvatarChat(file)
      this.capa = file
    },
    async salvarCurso() {
      await this.uploadCapaCurso()
      console.log('SALVAR CURSO')
      console.log('NOME CURSO', this.nomeCursoNOVO)
      console.log('Descricao CURSO', this.descricaoCursoNOVO)
      console.log('IMAGEM', this.capa)
      await apiBack.post('/createCurso', {
        nome: this.nomeCursoNOVO,
        descricao: this.descricaoCursoNOVO,
        capa: this.capa,
        status: 1,
        id_user: this.getUserData.id,
      })
        .then(() => {
          this.listarCurso()
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })
        .catch(err => console.error(err))
    },
    async uploadCapaCurso() {
      const formData = new FormData()
      formData.append('video', this.capa)
      formData.append('caminho', `${this.getUserData.user_file_key}`)
      await apiAws.post('/thumb', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(async response => {
        this.capa = response.data.data.fileUrl
      }).catch(err => {
        console.log(err)
      })
    },
    handleFileChange(event) {
      this.selectedFile = event.target.files[0]
    },
    async uploadFile() {
      try {
        const formData = new FormData()
        formData.append('file', this.selectedFile)
        console.log(this.selectedFile)

        const response = await apiBack.post('/upload-aluno', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        console.log(response.data)
      } catch (error) {
        console.error(error)
      }
    },
    updatedImagem(event) {
      console.log(event)
      this.capa = event
    },
  },
}
</script>
<style scoped>

</style>
